import { createConfirmation } from "react-confirm";
import AddSalaryDialog from "./AddSalaryDialog";

export const showAddSalaryDialog = createConfirmation(AddSalaryDialog);
